import styled from 'styled-components';

import { Assets } from '../../../utils/assets';

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 2rem;
`;

const Benefit = styled.div`
  display: flex;
  padding: 0.5rem 2rem;
  justify-content: center;
  align-items: center;
`;

const BenefitImage = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.75rem;
`;

const BenefitText = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSize.small};
`;

const PlanBenefits: React.FC = () => {
  return (
    <Container>
      <Benefit>
        <BenefitImage alt={Assets.icons.infinity.alt} src={Assets.icons.infinity.url} />
        <BenefitText>Unlimited Sessions </BenefitText>
      </Benefit>
      <Benefit>
        <BenefitImage alt={Assets.icons.download.alt} src={Assets.icons.download.url} />
        <BenefitText>Offline Access</BenefitText>
      </Benefit>
      <Benefit>
        <BenefitImage alt={Assets.icons.categories.alt} src={Assets.icons.categories.url} />
        <BenefitText>Access All Categories</BenefitText>
      </Benefit>
      <Benefit>
        <BenefitImage alt={Assets.icons.cancel.alt} src={Assets.icons.cancel.url} />
        <BenefitText>Cancel Anytime</BenefitText>
      </Benefit>
    </Container>
  );
};

export default PlanBenefits;
